import { type FC, type ReactNode, type Ref } from "react";

import clsx from "clsx";

// Room left of the frame (ml-12), outside the page, for a control beside it (`gutter`).
export const FRAME_GUTTER = 48;

// A document drawn in its own frame, filling the pane, on the pane's own
// background. The caller sets what the frame may do (`sandbox`) and its
// starting document.
export const DocumentFrame: FC<{
  title: string;
  sandbox: string;
  srcDoc: string;
  frameRef: Ref<HTMLIFrameElement>;
  gutter?: boolean;
}> = ({ title, sandbox, srcDoc, frameRef, gutter }) => (
  <iframe
    ref={frameRef}
    title={title}
    sandbox={sandbox}
    srcDoc={srcDoc}
    className={clsx(
      "min-h-0 flex-1",
      gutter ? "ml-12 w-[calc(100%-3rem)]" : "w-full",
    )}
  />
);

// The right half holding a DocumentFrame: notices over it, the frame below,
// in the same panel as the report's pages (ReportPagesColumn), so switching
// between them keeps the pane's edges.
export const DocumentPane: FC<{ hidden?: boolean; children: ReactNode }> = ({
  hidden,
  children,
}) => (
  <div
    hidden={hidden}
    className="flex min-h-0 min-w-0 flex-1 flex-col rounded-lg border border-slate-200 bg-slate-100 p-4"
  >
    {children}
  </div>
);
